module.exports = __webpack_public_path__ + "media/images/times-60ba2f685cdb4d4c825abcafc7b84fe5.svg";